import { TruncatingBadgeWebElementBase } from './TruncatingBadgeWebElementBase';

/**
 * The component WebElement for [oj-c-truncating-badge](../../../oj-c/docs/oj.TruncatingBadge.html).
 * Do not instantiate this class directly, instead, use
 * [findTruncatingBadge](../functions/findTruncatingBadge.html).
 */
export class TruncatingBadgeWebElement extends TruncatingBadgeWebElementBase {
  // Put overrides here
}
